//import { type Fingerprint } from "../interfaces/browser";
import AuthService from "../services/auth-service";
import { getFingerprint, /*removeNullAndUndefinedFromFingerprint*/ } from "./browser";
import logger from "./logger";
import { fetchWithTimeout as fetch, isServerDownError } from "./http";

const request = createHttpRequestApi();

export default request;

type FetchOptions = RequestInit;
type RequestPayload = FormData | Record<string, unknown>;
interface IMakeRequest {
  method: string;
  endpoint: string; 
  payload?: RequestPayload;
  fetchOptions?: FetchOptions;
}

function createHttpRequestApi() {
  return ["GET", "POST", "PUT", "DELETE"].reduce((acc, method) => {
    acc[method.toLowerCase()] = acc[method] = async function(endpoint: string, payload?: RequestPayload, fetchOptions?: FetchOptions) {
      return await makeRequest({ method, endpoint, payload, fetchOptions });
    };

    return acc;
  }, {});
}

/**
 * Make HTTP request to an endpoint
 */
//async function makeRequest(reqMethod: string, endpoint: string, payload?: FormData | Record<string, unknown>): Promise<Response | undefined> {
async function makeRequest(requestOptions: IMakeRequest): Promise<Response | undefined> { 
  const { method: reqMethod, endpoint, payload, fetchOptions } = requestOptions;

  try {
    const url = endpoint;
    const method = reqMethod.toUpperCase();
    const isFormData = payload instanceof FormData;
    const fingerprint = await getFingerprint();
    //const fingerprintHeaders = removeNullAndUndefinedFromFingerprint(fingerprint);
    const headers: Record<string, string> = {
      "Authorization": AuthService.getBearerToken(), // `Bearer ${AuthService.getAccessToken()}`,
      "X-Metrics": JSON.stringify(fingerprint), 
      //...fingerprintHeaders,
    };
    const requestConfig: RequestInit = { 
      ...(fetchOptions ?? {}),
      method,
      credentials: "include",
      headers: isFormData
        ? { ...headers }
        : { ...headers, "Content-Type": "application/json" },
    };

    if(method !== "GET" && payload) {
      requestConfig.body = isFormData ? payload : JSON.stringify(payload);
    }

    return await fetch(url, requestConfig);
  } catch(error) {
    logger.error("helpers.request:: HTTP Request Error:", endpoint, error);

    if(isServerDownError(error)) {
      //throw error; 
      logger.error(
        "helpers.request:: HTTP Request Error:", 
        endpoint, 
        { message: "The server is temporarily down" }
      );
    }

    return undefined;
  }
}
